import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$siteSlug/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div className="max-w-3xl">
      <h1 className="text-lg font-semibold">Settings</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Configure this site — general details, generation, databases, and email. API keys live under Account.
      </p>
      <Outlet />
    </div>
  );
}
